'use strict';

wbApp.factory('franchiseSvc', ['$resource', '$cacheFactory', '$q', 'repositorySvc', 
    function ($resource, $cacheFactory, $q, repositorySvc) {

        var Franchise = $resource('/Api/Franchise/Get', {}, {
            'getAll': { method: 'GET', isArray: true, url: '/Api/Franchise/GetAll' },
            'getEmployeesByTenant': { method: 'GET', isArray: true, url: '/Api/Franchise/GetEmployeesByTenant' },
            'updateEmployeeByTenant': { method: 'POST', isArray: false, url: '/Api/Franchise/UpdateEmployeeByTenant' },
            'getAttendanceSummary': { method: 'GET', isArray: true, url: '/Api/Franchise/GetAttendanceSummary' },
            'getAttendanceSummaryForFranchiseCentral': { method: 'GET', isArray: true, url: '/Api/Franchise/GetAttendanceSummaryForFranchiseCentral' },
        });

        var cache = $cacheFactory('franchiseSvcCache');

        function getAllAsync(refresh) {

            var models = cache.get('franchises');

            if (refresh || !models) {
                if (models) {
                    cache.remove('franchises');
                }

                models = repositorySvc.customGet('getAll', Franchise);
                cache.put('franchises', models);
            }

            return models;
        }

        function getAttendanceSummaryAsync(fromDate, toDate) {
            return repositorySvc.customGet('getAttendanceSummary', Franchise, {
                fromDate: fromDate,
                toDate: toDate
            });
        }

        function getAttendanceSummaryForFranchiseCentral(franchiseCentralTenantID, fromDate, toDate) {
            return repositorySvc.customGet('getAttendanceSummaryForFranchiseCentral', Franchise, {
                franchiseCentralTenantID: franchiseCentralTenantID,
                fromDate: fromDate,
                toDate: toDate
            });
        }

        function getEmployeesByTenant(tenant) {
            var deferred = $q.defer();
            var result = [];
            result.$promise = deferred.promise;

            repositorySvc.customGet('getEmployeesByTenant', Franchise, {
                employeesForTenantAlias: tenant
            }).$promise.then(
            function (data) {
                angular.forEach(data, function (value) {
                    result.push(new webooker_franchise_models.FranchiseEmployee(value));
                });
                deferred.resolve(result);
            },
            function (reason) { deferred.reject(reason); });

            return result;
        }

        function updateEmployeeByTenant(tenant, employee, success, error) {
            repositorySvc.customPost(
                'updateEmployeeByTenant',
                Franchise,
                {
                    employeesForTenantAlias: tenant,
                    employee: employee.employeeDTO
                },
                function (data) {
                    if (success) {
                        success(new webooker_franchise_models.FranchiseEmployee(data));
                    }
                },
                error
            );
        }

        return {
            getAllAsync: getAllAsync,
            getEmployeesByTenant: getEmployeesByTenant,
            updateEmployeeByTenant: updateEmployeeByTenant,
            getAttendanceSummaryAsync: getAttendanceSummaryAsync,
            getAttendanceSummaryForFranchiseCentral: getAttendanceSummaryForFranchiseCentral
        }
    }
]);
